<span class="buttons-container">
  @if (optionsButtons()) {
    <myre-actions-dropdown
      [dropdownItems]="optionsButtons()"
      icon="myre-icon-menu"
      [buttonTheme]="_ButtonTheme.Secondary"
      [buttonSubTheme]="_ButtonSubTheme.Blue"
      [buttonHeight]="_ButtonHeight.Medium"
    />
  }

  @if (_secondaryButtons()?.length) {
    <span class="buttons-container__secondary">
      <ng-container
        *ngTemplateOutlet="
          buttonsTemplate;
          context: {
            $implicit: _secondaryButtons(),
            theme: _ButtonTheme.Secondary,
            defaultSubTheme: _ButtonSubTheme.Blue,
          }
        "
      />
    </span>
  }

  @if (_primaryButtons()?.length) {
    <span class="buttons-container__primary">
      <ng-container
        *ngTemplateOutlet="
          buttonsTemplate;
          context: {
            $implicit: _primaryButtons(),
            theme: _ButtonTheme.Primary,
            defaultSubTheme: _ButtonSubTheme.Blue,
          }
        "
      />
    </span>
  }
</span>

<ng-template
  #buttonsTemplate
  let-buttons
  let-theme="theme"
  let-defaultSubTheme="defaultSubTheme"
>
  @for (actionButton of buttons; track _track($index, actionButton)) {
    @if (_actionButton(actionButton); as button) {
      <myre-button
        [label]="button.label"
        [icon]="button.icon"
        [disabled]="button.disabled"
        [tooltipDisabled]="button.tooltipDisabled"
        [theme]="theme"
        [subTheme]="button.subTheme || defaultSubTheme"
        [isLoading]="
          _isSignal(button.isLoading) ? button.isLoading() : button.isLoading
        "
        [tooltipLoading]="button.tooltipLoading"
        [id]="'btn-' + button.id"
        [ariaLabel]="button.ariaLabel"
        (onClick)="button.onClick($event)"
      />
    }
  }
</ng-template>
